module.exports = __webpack_public_path__ + "img/Icon-sidebar-Users.19197118.svg";